/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon16Solid = forwardRef('ArrowFigureACircleDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14ZM8 3.484a.75.75 0 0 1 .75.75V9.85l1.642-1.844a.75.75 0 1 1 1.12.998L9.307 11.48a1.75 1.75 0 0 1-2.614 0L4.488 9.004a.75.75 0 0 1 1.12-.998L7.25 9.85V4.234a.75.75 0 0 1 .75-.75Z" })));
});
